import React from 'react';
import LoginByPhonePage from '../components/Views/LoginByPhonePage';

const LoginByPhone = () => <LoginByPhonePage />;

export default LoginByPhone;
